
import { defineComponent } from 'vue';
import Form from '@/shared/mixins/Form';
import { accountService } from './AccountService';
import { required } from '@vuelidate/validators';
import store from '@/store';
import useVuelidate from '@vuelidate/core';
import config from '@/shared/constants/config';
import PhonePrefix from '@/shared/components/PhonePrefix.vue';
import phoneNumber from '@/shared/helpers/phoneNumberValidator';

export default defineComponent({
  name: 'BasicUserProfileEdit',
  mixins: [Form],
  components: {
    PhonePrefix,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        lastName: '',
        email: '',
        phoneNumberPrefix: config.DEFAULT_PHONE_PREFIX,
        phoneNumber: '',
      },
    };
  },
  validations() {
    return {
      form: {
        lastName: { required },
        email: { required },
        phoneNumberPrefix: {},
        phoneNumber: { phoneNumber: phoneNumber(this.form.phoneNumberPrefix) },
      },
    };
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await accountService.getProfile();
      this.form = result.data;
      if (result.data.phoneNumberPrefix) {
        this.form.phoneNumberPrefix = config.PHONE_PREFIXES.find((x) => x.value === result.data.phoneNumberPrefix);
      }
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    onEdit() {
      this.isSuccess = false;
      this.isError = false;
    },
    async send() {
      if (!this.validate()) return;

      try {
        const form = Object.assign({}, this.form);

        if (form.phoneNumberPrefix && form.phoneNumberPrefix.value) {
          form.phoneNumberPrefix = form.phoneNumberPrefix.value;
        }

        await accountService.updateProfile(form);
        this.success(false);
        store.dispatch('userUpdate', { lastName: form.lastName });
        this.$router.push({ name: 'UserProfile' });
      } catch (error) {
        this.handleApiError(error);
      }
    },
  },
});
